import React, {useMemo} from 'react'
import styles from './styles.css'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import useState from 'App/hooks/useState'
import useDebounce from 'App/hooks/useDebounce'
import Select from 'react-select'

export default function ServerSelect(props) {
  const {multi, autoFocus, searchQuery, valuesQuery, searchParams} = props

  const value = multi ? props.value || [] : props.value

  const [filter, setFilter] = useState('')
  const [debouncedFilter, isDebouncing] = useDebounce(filter, 400)
  const [pendingValues, setPendingValues] = useState(multi ? [] : null)

  const cleanValue = item => {
    if (!item) return null
    if (!props.cleanValue) return item
    return props.cleanValue(item)
  }

  const {searchItems, networkStatus} = useQuery({
    query: searchQuery,
    variables: {filter: debouncedFilter, ...searchParams},
    fetchPolicy: 'network-only',
    partial: true
  })

  const {values, networkStatus: valueNetworkStatus} = useQuery({
    query: valuesQuery,
    variables: {valuesIds: value},
    partial: true
  })

  const selectValue = useMemo(
    () => {
      if (valueNetworkStatus !== 7) return pendingValues

      if (multi) {
        return (values || []).map(cleanValue)
      } else {
        return cleanValue((values || [])[0])
      }
    },
    [valueNetworkStatus, value]
  )

  const onChange = options => {
    if (multi) {
      props.onChange(options ? options.map(option => option.value) : [])
    } else {
      props.onChange(options ? options.value : null)
    }
    setPendingValues(options)
  }

  const isLoading = networkStatus !== 7 || isDebouncing
  return (
    <div className={styles.container}>
      <div className="label">{props.label}</div>
      <Select
        isMulti={multi}
        value={selectValue}
        onChange={onChange}
        placeholder={props.placeholder || 'Buscar'}
        classNamePrefix="orion-select"
        isLoading={isLoading}
        inputValue={filter}
        onInputChange={setFilter}
        isClearable
        autoFocus={autoFocus}
        noOptionsMessage={() => 'No se encontró ningún elemento'}
        options={isLoading ? [] : (searchItems || {items: []}).items.map(cleanValue)}
      />
      <div className="description">{props.description}</div>
      <div className="os-input-error">{props.errorMessage}</div>
    </div>
  )
}
